import React from "react";
import styles from "./PatientDetails.module.scss";
import {MaleIcon} from "../../assets";
import {InfoText} from "../../shared";
import moment from "moment/moment";

const PatientDetails = ({request}) => {
  return <div className={styles.container}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        <MaleIcon  className='mr-5'/>
        <div className={styles.title} >Реквизиты</div>
      </div>
    </div>
    {request && request?.customer?.role === 2 ? <div className={styles.body}>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcText} title={'Руководитель (ФИО)'} text={request?.customer?.director_name}/>
        <InfoText className={styles.dcText} title={'Наименование банка'} text={request?.customer?.bank_name}/>
      </div>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcText} title={'БИК банка'} text={request?.customer?.bic}/>
        <InfoText className={styles.dcText} title={'Расчетный счет'} text={request?.customer?.account}/>
      </div>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcText} title={'Корр/счет'} text={request?.customer?.correspondent_account}/>
        <InfoText className={styles.dcText} title={'ОКВЭД'} text={request?.customer?.activity_classifier}/>
      </div>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcText} title={'ОГРН'} text={request?.customer?.register_number}/>
        <InfoText className={styles.dcText} title={'Номер Лицензии'} text={request?.customer?.license_number}/>
      </div>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcText} title={'Лицензия Действителна До'}
                  text={`${moment(request?.customer?.license_date).format('DD/MM/YYYY')}`}/>
        <InfoText className={styles.dcText} title={'Орган Выдачи Лицензий'}
                  text={request?.customer?.license_authority}/>
      </div>
    </div>:
      <div className={styles.body}>
        <div className={styles.wrapper}>
          <InfoText className={styles.dcText} title={'Тип Документа'} text={request?.customer?.document_name}/>
          <InfoText className={styles.dcText} title={'Дата Выдачи'} text={`${moment(request?.customer?.document_date).format('DD/MM/YYYY')}`}/>
        </div>
        <div className={styles.wrapper}>
          <InfoText className={styles.dcText} title={'Страна'} text={request?.customer?.document_country}/>
          <InfoText className={styles.dcText} title={'Серия'} text={request?.customer?.document_number}/>
        </div>
      </div>}
  </div>
}

export default PatientDetails
